import { ChangeDetectionStrategy, Component, ElementRef, Input, signal, ViewChild, WritableSignal } from "@angular/core";
import { SafeHtml } from "@angular/platform-browser";

@Component({
  selector: "app-google-logo-svg",
  standalone: true,
  templateUrl: "./google-logo.svg",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleLogoSvgComponent {
  @Input() height: string = "auto";
  @Input() width: string = "auto";

  svgContent: WritableSignal<SafeHtml> = signal(undefined);

  @ViewChild("div") div: ElementRef;
}
